import { useLocation, useNavigate } from "react-router-dom";
import useDecodedToken from "../../../hooks/userHooks/useDecodedToken";
import CurrentUserProfilePage from "./CurrentUserProfilePage";
import OtherUserProfilePage from "./OtherUserProfilePage";

type Props = {
  username: string;
};

function ProfileWrapper({ username }: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const collectionTab = searchParams.get("ctc");
  const { connectedUsername, role, sourceId } = useDecodedToken();

  const fromPayment = sessionStorage.getItem("payment-page") === "True";

  const handleNavigate = () => {
    localStorage.removeItem("activeProfileTab");
    if (fromPayment) {
      navigate("/common/discover");
      sessionStorage.removeItem("payment-page");
    } else if (collectionTab) {
      navigate(-3);
    } else {
      navigate(-1);
    }
  };

  if (connectedUsername === username) {
    return <CurrentUserProfilePage />;
  } else {
    return <OtherUserProfilePage username={username} handleNavigate={handleNavigate} currentUserRole={role} currentUserId={sourceId} />;
  }
}

export default ProfileWrapper;
